import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import ACTCONSTANT from '../constant/activity'
import _ from 'underscore'
import cookie from '../lib/cookie'

const getHomeActStatus = () => {
  const HOMEACTSTATUSISJOINED = 6813001
  return new Promise( (resolve, reject)=> {
    Api.get(`${CONSTANT.REQUEST_HOST}` ,{
      headers: {
        'X-Host':'mall.act.guide-act.check',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    })
    .then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    },
    (e)=> {
      reject(e)
    })
  })
}

const getHomeFloatBanner = () => {
  return new Promise( (resolve, reject)=> {
    Api.get(`${CONSTANT.REQUEST_HOST}` ,{
      headers: {
        'X-Host':'mall.cfg.float-banner',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    })
    .then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    },
    (e)=> {
      reject(e)
    })
  })
}

const getUUGRoupActList = (data) => {
  return new Promise((resolve, reject) => {
    Api.post(`${CONSTANT.REQUEST_HOST}?${qs.stringify(data)}` ,{
      headers: {
        'X-Host':'mall.act.group-act.act-list',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    }).then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    }, (e)=> {
      reject(e)
    })
  })
}

const getUUGRoupActDetail = (id) => {
  return new Promise((resolve, reject) => {
    // let url = 'https://easy-mock.com/mock/5902f1a57a878d73716e013c/api/getUUGRoupActDetail'
    let url = `${CONSTANT.REQUEST_HOST}?activeCode=${id}`
    Api.get(url ,{
      headers: {
        'X-Host':'mall.act.group-act.act-sum-info',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    }).then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    }, (e)=> {
      reject(e)
    })
  })
}

const getUUGRoupActGroupList = (data) => {
  return new Promise((resolve, reject) => {
    // let url = 'https://easy-mock.com/mock/5902f1a57a878d73716e013c/api/getUUGRoupActGroupList'
    let url = `${CONSTANT.REQUEST_HOST}?${qs.stringify(data)}`
    Api.get(url ,{
      headers: {
        'X-Host':'mall.group.group-list',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    }).then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    }, (e)=> {
      reject(e)
    })
  })
}

const getUUGroupActGroupDetail = (info) => {
    // let url = 'https://easy-mock.com/mock/5902f1a57a878d73716e013c/api/getUUGroupActGroupDetailOK'
    // let url = 'https://easy-mock.com/mock/5902f1a57a878d73716e013c/api/getUUGroupActGroupDetailfail'
    // let url = 'https://easy-mock.com/mock/5902f1a57a878d73716e013c/api/getUUGroupActGroupDetail'
  let url = `${CONSTANT.REQUEST_HOST}?${qs.stringify(info)}`
    return new Promise((resolve, reject) => {
    Api.get(url , {
      headers: {
        'X-Host':'mall.group.group-user',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
      }
    }).then((data) => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data)
    }, (e)=> {
      reject(e)
    })
  })
}

/*yeoman-template-point-1*/
export default {
    getHomeActStatus,
    getHomeFloatBanner,
    getUUGRoupActList,
    getUUGRoupActDetail,
    getUUGRoupActGroupList,
    getUUGroupActGroupDetail,
/*yeoman-template-point-2*/
}
